@use "../../../../globals/bcp";

:host {
  display: block;
}

.flyout-loader {
  display: flex;
  width: bcp.cssVar(flyout-loader, width, 100%);
  height: bcp.cssVar(flyout-loader, height, auto);
  align-items: bcp.cssVar(flyout-loader, h-align, center);
  justify-content: bcp.cssVar(flyout-loader, v-align, center);
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
